<template>
	<div class="hello">
		<div class="headCsslogin">
			<div class="head-time" v-if="languageCheck == 'English'">
				<span v-if="newTime.getDay() == 0">Sunday</span>
				<span v-else-if="newTime.getDay() == 1">Monday</span>
				<span v-else-if="newTime.getDay() == 2">Tuesday</span>
				<span v-else-if="newTime.getDay() == 3">Wednesday</span>
				<span v-else-if="newTime.getDay() == 4">Thursday</span>
				<span v-else-if="newTime.getDay() == 5">Friday</span>
				<span v-else-if="newTime.getDay() == 6">Saturday</span>
				<span
					style="margin: 0 0.2vw;">,{{ newTime.getMonth()+1 }}/{{ newTime.getDate() }}/{{ newTime.getFullYear() }}</span>
				<span>{{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}</span>
				<span style="margin-left: 0.2vw;"> {{ newTime.getHours() > 12 ? 'PM' : 'AM' }} </span>
			</div>
			<div class="head-time" v-else>
				<span
					style="margin-right: 5px;">{{newTime.getFullYear()}}-{{newTime.getMonth() + 1}}-{{ newTime.getDate() < 10 ? '0' + newTime.getDate() : newTime.getDate()}}</span>
				<span v-if="newTime.getDay() == 0">星期日</span>
				<span v-else-if="newTime.getDay() == 1">星期一</span>
				<span v-else-if="newTime.getDay() == 2">星期二</span>
				<span v-else-if="newTime.getDay() == 3">星期三</span>
				<span v-else-if="newTime.getDay() == 4">星期四</span>
				<span v-else-if="newTime.getDay() == 5">星期五</span>
				<span v-else-if="newTime.getDay() == 6">星期六</span>
				<span
					style="margin-left: 5px;">{{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}:{{ newTime.getSeconds() < 10 ? '0' + newTime.getSeconds() : newTime.getSeconds() }}</span>
			</div>
			<img :src="headImg" style="width: 100%;" alt="">
			<div :class="languageCheck == 'English' ? 'head-text head-text-font' : 'head-text'">{{ languageJson.adminText }}</div>
			<el-popover placement="bottom" trigger="click" popper-class="popoverBackB">
				<div>
					<div :class="languageCheck == 'Chinese' ? 'lenDom lenDomCheck' : 'lenDom'" @click="checkLanguage('Chinese')">
						简体中文（CN）
						<i v-if="languageCheck == 'Chinese'" class="el-icon-check" style="color: white;"></i>
					</div>
					<div :class="languageCheck == 'Traditional' ? 'lenDom lenDomCheck' : 'lenDom'" @click="checkLanguage('Traditional')">
						繁体中文（TC）
						<i v-if="languageCheck == 'Traditional'" class="el-icon-check" style="color: white;"></i>
					</div>
					<div :class="languageCheck == 'English' ? 'lenDom lenDomCheck' : 'lenDom'" @click="checkLanguage('English')">
						英文（English）
						<i v-if="languageCheck == 'English'" class="el-icon-check" style="color: white;"></i>
					</div>
				</div>
				<img class="head-English" slot="reference" :src="require('../../static/imgV2/English.png')" alt="">
			</el-popover>
		</div>
		<img :src="backImg" style="width: 100%;" class="backimg" />
		<div class="login_">
			<div class="login_ul" :style="{backgroundImage: 'url(' + borderBack + ')'}">
				<!-- 滕州烟厂单点登录（SSO）：自动登录提示 -->
				<div v-if="isAutoLogging" class="auto-login-message">
					<p>正在自动登录，请稍候...</p>
				</div>
				<div v-else>
					<div class="cocoLog">
						<img :src="cocoImg" alt="">
					</div>
					<el-form ref="form" sizi="mini" label-position="left" :label-width=" languageCheck == 'English' ? '5vw' : '4vw' ">
						<el-form-item>
							<span slot="label">
								<span class="text-lable">{{ languageJson.userName }}</span>
							</span>
							<el-input v-model="fromAdd.account" maxlength='20'></el-input>
						</el-form-item>
						<el-form-item>
							<span slot="label">
								<span class="text-lable">{{ languageJson.passWord }}</span>
							</span>
							<el-input :type='inputType' v-model="fromAdd.password" maxlength='20'></el-input>
							<img v-if="inputType == 'password'" src="../../static/imgV2/closeEye.png"
								style="position: absolute;top: 16px;right: 10px;color: white;cursor: pointer;width: 1vw;"
								@click="inputType = 'text'" alt="">
							<i v-else class="el-icon-view"
								style="position: absolute;top: 12px;right: 10px;color: white;cursor: pointer;font-size: 0.9vw;"
								@click="inputType = 'password'"></i>
						</el-form-item>
						<el-form-item>
							<span slot="label">
								<span class="text-lable">{{ languageJson.role }}</span>
							</span>
							<el-select v-model="fromAdd.userType" :placeholder="languageJson.placeRole">
								<el-option v-for="(obj, $index) in typeList" :key="$index" :label="obj.type"
									:value="obj.value"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
					<div style="display: flex;flex-direction: row-reverse;">
						<div style="display: flex;justify-content: space-between;width: 12vw;align-items: flex-end;">
							<div style="color: white;display: flex;align-items: center;">
								<!-- <el-checkbox v-model="checked" style="margin-right: 5px;"></el-checkbox> -->
								<input type="checkbox" style="width: 0.8vw;height: 0.8vw;" v-model="checked">
								<span
									style="color: #4CF5FF;font-size: 0.7vw;margin-left: 0.2vw;">{{ languageJson.rememberPassWord }}</span>
							</div>
							<div style="color: #4CF5FF;font-size: 0.7vw;cursor: pointer;" @click='getCrc(1)'>
								{{ languageJson.obtain }}?</div>
						</div>
					</div>
					<div class="login_button" @click="login()">{{ languageJson.login }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		login,
		setLanguage
	} from '@/api/admin'
	import {
		setToken,
		getItem,
		setItem,
		removeItem,
		removeToken
	} from '@/utils/auth'
	export default {
		name: 'login',
		data() {
			return {
				isAutoLogging: false, // 滕州烟厂单点登录（SSO）：自动登录状态标识
				loginTimer: null,
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				adminCrc: '',
				backImg: require('../../static/imgV2/login.png'),
				borderBack: require('../../static/imgV2/login-1.png'),
				backTitle: require('../../static/img/login-new.png'),
				usertype: require('../../static/img/user-type.png'),
				cocoImg: require('../../static/imgV2/logo.png'),
				headImg: require('../../static/imgV2/head.png'),
				checked: false,
				newTime: new Date(),
				fromAdd: {
					account: '',
					password: '',
					userType: '',
					crc: '',
				},
				typeList: [{
						type: languageJson.roleMessage,
						value: '1'
					},
					{
						type: languageJson.roleStaff,
						value: '2'
					}
				],
				inputType: 'password'
			}
		},
		mounted() {
			let that = this
			let baseUrl = window.location.href;
			// 滕州烟厂单点登录（SSO）：第三方系统携带 _tk 参数跳转过来，自动完成登录并跳转到对应页面
			// URL格式: http://host/index.html?_tk={base64}#/
  			if (that.checkAutoLogin()) {
				// 已触发自动登录，不再执行 getCookie / autoMatic 等
			} else if (baseUrl.indexOf('name') >= 0) {
				that.getLocation()
			} else {
				that.getCookie()
			}
			if (baseUrl.indexOf('username') >= 0) {
				that.autoMatic()
			}
			that.loginTimer = setInterval(() => {
				that.newTime = new Date()
			}, 1000)
			if (navigator.language.indexOf('en') != -1) {
				if (!getItem('language')) {
					setItem('language', 'English')
					location.reload()
				}
			}
		},
		beforeDestroy() {
			let that = this
			if (that.loginTimer) {
				clearInterval(that.loginTimer)
				that.loginTimer = null
			}
		},
		methods: {
			autoMatic() {
				this.fromAdd.account = this.$route.query.username
				this.fromAdd.password = this.$route.query.password
				this.fromAdd.userType = this.$route.query.userType
				this.fromAdd.crc = '0670c709b0e3'
				this.login()
			},
			checkLanguage(type) {
				setItem('language', type)
				location.reload()
			},
			uncompile(code) {
				code = unescape(code);
				var c = String.fromCharCode(code.charCodeAt(0) - code.length);
				for (var i = 1; i < code.length; i++) {
					c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
				}
				return c;
			},
			clearCookie() {
				this.setCookie('', '', false, -1)
			},
			getLocation() {
				this.fromAdd.account = this.$route.query.name
				this.fromAdd.password = this.uncompile(this.$route.query.password)
				this.fromAdd.userType = '1'
			},
			getCookie() {
				let that = this
				if (document.cookie.length > 0) {
					const arr = document.cookie.split('; ')
					for (let i = 0; i < arr.length; i++) {
						const arr2 = arr[i].split('=')
						if (arr2[0] === 'username') {
							that.fromAdd.account = arr2[1]
						} else if (arr2[0] === 'password') {
							that.fromAdd.password = arr2[1]
						} else if (arr2[0] === 'state') {
							that.checked = Boolean(arr2[1])
						}
					}
				}
			},
			setCookie(c_name, c_pwd, c_state, exdays) {
				const exdate = new Date()
				exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
				window.document.cookie = 'username' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
				window.document.cookie = 'password' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
				window.document.cookie = 'state' + '=' + c_state + ';path=/;expires=' + exdate.toGMTString()
			},
			bin2hex(str, opentype) {
				let that = this
				var result = "";
				for (var i = 0; i < str.length; i++) {
					result += that.int16_to_hex(str.charCodeAt(i));
				}
				if (opentype) {
					that.$alert(that.languageJson.obtainCode + result, {
						confirmButtonText: that.languageCheck == 'English' ? 'ok' : '确定'
					});
				}
				return result;
			},
			int16_to_hex(i) {
				var result = i.toString(16);
				var j = 0;
				while (j + result.length < 4) {
					result = "0" + result;
					j++;
				}
				return result;
			},
			getCrc(opentype) {
				var canvas = document.createElement('canvas');
				var ctx = canvas.getContext('2d');
				var txt = 'http://security.tencent.com/';
				ctx.textBaseline = "top";
				ctx.font = "14px 'Arial'";
				ctx.textBaseline = "tencent";
				ctx.fillStyle = "#f60";
				ctx.fillRect(125, 1, 62, 20);
				ctx.fillStyle = "#069";
				ctx.fillText(txt, 2, 15);
				ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
				ctx.fillText(txt, 4, 17);
				var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
				var bin = atob(b64);
				var crc = this.bin2hex(bin.slice(-16, -12), opentype);
				if (!opentype) {
					return this.bin2hex(bin.slice(-16, -12), opentype);
				}
				//var crc = bin.slice(-16,-12);
			},
			login() {
				let that = this
				removeItem('differtime')
				that.fromAdd.crc = that.getCrc(0)
				if (!that.fromAdd.account) {
					that.$notify.error({
						title: that.languageJson.userNamePrompt
					})
					return false
				}
				if (!that.fromAdd.password) {
					that.$notify.error({
						title: that.languageJson.passWordPrompt
					})
					return false
				}
				if (!that.fromAdd.userType) {
					that.$notify.error({
						title: that.languageJson.rolePrompt
					})
					return false
				}
				let langZh = ''
				if (getItem('language') == 'English') {
					langZh = 'en_US'
				} else if (getItem('language') == 'Traditional') {
					langZh = 'zh_HK'
				} else {
					langZh = 'zh_CN'
				}
				login({
					...that.fromAdd,
					'lang': langZh,
				}).then(res => {
					if (that.checked === true) {
						that.setCookie(that.fromAdd.account, that.fromAdd.password, true, 7)
					} else {
						that.clearCookie()
					}
          setItem('webRtcId',res.data.tenantInfoId + '_' + new Date().getTime())
					setItem('kakcrc', that.fromAdd.crc)
					setItem('loginSuccess', new Date().getTime())
					setToken(res.data.token)
          setItem('token1', res.data.token)
					setItem('userInfo', res.data.userInfo)
					setItem('tenantInfoId', res.data.tenantInfoId)
					if (getItem('language') == 'English') {
						setLanguage('en_US').then(res => {
							setItem('language', 'English')
							that.setUpBack(res.data.userInfo)
						})
					} else {
						that.setUpBack(res.data.userInfo)
					}
				})
			},
			setUpBack(res) {
				let that = this
				if (this.fromAdd.userType === '1') {
					this.$router.push({
						name: 'customindex'
					})
				} else if (this.fromAdd.userType === '2') {
					this.$router.push({
						name: 'user'
					})
				}
			},
			// ========== 滕州烟厂单点登录（SSO）开始 ==========
			// 第三方系统传参格式: ?_tk=eyJhY2NvdW50IjoiY29nc3N0YWZmMSIsInBhc3N3b3JkIjoiMTIzNDU2IiwidXNlclR5cGUiOiIyIn0
			// _tk 值为 JSON {"account":"xxx","password":"xxx","userType":"1"} 的Base64编码
			// 流程：第三方系统登录成功后，携带 _tk 参数跳转到本项目，本项目解密后自动调用登录接口，用户无感知完成登录
			checkAutoLogin() {
				const urlParams = new URLSearchParams(window.location.search)
				const encoded = urlParams.get('_tk')
				if (encoded) {
					try {
						// Base64 解码，补齐可能的 padding
						let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/')
						const pad = base64.length % 4
						if (pad) base64 += '='.repeat(4 - pad)
						const jsonStr = decodeURIComponent(escape(atob(base64)))
						const { account, password, userType } = JSON.parse(jsonStr)
						if (account && password && userType) {
							this.performAutoLogin(account, password, userType)
							return true
						}
					} catch (e) {
						console.error('登录参数解密失败:', e)
						this.$message.error('登录参数解析失败')
						this.clearUrlParams()
					}
				}
				return false
			},
			// 滕州烟厂单点登录（SSO）：解密成功后，自动调用登录接口完成无感登录
			async performAutoLogin(account, password, userType) {
				try {
					this.isAutoLogging = true // 开始自动登录
				    console.log('开始自动登录:', { account, userType })
				// 设置表单数据
				this.fromAdd.account = account
				this.fromAdd.password = password
				this.fromAdd.userType = userType
				this.fromAdd.crc = this.getCrc(0)
				let langZh = ''
				if (getItem('language') == 'English') {
					langZh = 'en_US'
				} else if (getItem('language') == 'Traditional') {
					langZh = 'zh_HK'
				} else {
					langZh = 'zh_CN'
				}
				// 调用登录接口
				const res = await login({
					...this.fromAdd,
					'lang': langZh,
				})
				if (res && res.data) {
					console.log('自动登录成功')
					// 保存登录信息（与正常登录 login() 保持一致）
					setItem('webRtcId', res.data.tenantInfoId + '_' + new Date().getTime())
					setItem('kakcrc', this.fromAdd.crc)
					setItem('loginSuccess', new Date().getTime())
					setToken(res.data.token)
					setItem('token1', res.data.token)
					setItem('userInfo', res.data.userInfo)
					setItem('tenantInfoId', res.data.tenantInfoId)
					// 清除URL参数
					this.clearUrlParams()
					// 跳转到对应页面
					if (getItem('language') == 'English') {
					setLanguage('en_US').then(langRes => {
						setItem('language', 'English')
						this.setUpBack(res.data.userInfo)
					})
					} else {
					this.setUpBack(res.data.userInfo)
					}
				}
				} catch (error) {
				console.error('自动登录失败:', error)
				this.$message.error('自动登录失败: ' + (error.message || '请检查参数'))
				
				// 清除无效的参数
				this.clearUrlParams()
				}
			},
			// 滕州烟厂单点登录（SSO）：登录完成后清除URL中的 _tk 参数
			clearUrlParams() {
				if (window.history.replaceState) {
				const cleanUrl = window.location.origin + window.location.pathname
				window.history.replaceState({}, document.title, cleanUrl)
				console.log('已清除URL参数')
				}
			},
  
	// ========== 滕州烟厂单点登录（SSO）结束 ==========
	}
	}
</script>

<style>
	.popoverBackB {
		background: rgba(0, 15, 50, 0.95) !important;
		border: 1px solid rgba(0, 240, 255, 0.2) !important;
		padding: 0 !important;
		color: white;
		backdrop-filter: blur(10px);
	}

	.popoverBackB .popper__arrow::after {
		background: rgba(0, 15, 50, 0.95);
		border-bottom-color: rgba(0, 15, 50, 0.95) !important;
	}

	.el-popper .popper__arrow {
		display: none;
	}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.auto-login-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 16px;
  color: var(--neon-cyan, #00f0ff);
  font-weight: bold;
  animation: textGlow 2s ease-in-out infinite;
}

	.lenDom {
		padding: 0.3vw 0.5vw;
		font-size: 0.7vw;
		cursor: pointer;
		transition: all 0.3s ease;
		border-left: 2px solid transparent;

		&:hover {
			background: rgba(0, 240, 255, 0.1);
			border-left-color: var(--neon-cyan, #00f0ff);
		}
	}

	.lenDomCheck {
		background-color: rgba(0, 128, 255, 0.3);
		border-left-color: var(--neon-cyan, #00f0ff);
	}

	.text-lable {
		font-size: 0.8vw;
		font-weight: 600;
		color: #c0e0ff;
		letter-spacing: 1px;
	}

	.login_ /deep/ .el-input__inner {
		width: 12vw;
		color: #e0f0ff;
		border-radius: 4px;
		background: rgba(0, 20, 60, 0.6);
		height: 1.7vw;
		line-height: 1.7vw;
		border: 1px solid rgba(0, 240, 255, 0.25);
		font-size: 0.7vw;
		backdrop-filter: blur(4px);
		transition: all 0.3s ease;

		&:focus {
			border-color: var(--neon-cyan, #00f0ff);
			box-shadow: 0 0 10px rgba(0, 240, 255, 0.3), inset 0 0 10px rgba(0, 240, 255, 0.05);
		}
	}

	.login_ /deep/ .el-form-item {
		margin-bottom: 0.7vw;
		display: flex;
		align-items: center;
	}

	.login_ /deep/ .el-form-item__label {
		width: 3vw;
	}

	.login_ /deep/ .el-form-item__content {
		margin-left: 0vw !important;
	}

	.login_ /deep/ .el-form--label-left .el-form-item__label {
		text-align: right;
	}

	.hello {
		height: 100%;
		display: flex;
		align-items: center;
		position: relative;
		overflow: hidden;

		.backimg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100% !important;
			height: 100%;
			z-index: 1;
			object-fit: cover;
		}
	}

	.headCsslogin {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		z-index: 99;

		.head-time {
			position: absolute;
			left: 30px;
			top: 0px;
			color: #c0e0ff;
			height: 70%;
			font-size: 1.2vw;
			font-weight: 700;
			display: flex;
			align-items: center;
			letter-spacing: 1px;
			animation: textGlow 4s ease-in-out infinite;
		}

		.head-text {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 80%;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			font-size: 2.1vw;
			font-weight: 900;
			font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
			letter-spacing: 4px;
			text-shadow: 0 0 10px rgba(0, 240, 255, 0.5), 0 0 20px rgba(0, 240, 255, 0.2), 0px 2px 4px rgba(255, 255, 255, 0.3);
			background: linear-gradient(180deg, #ffffff 20%, #00f0ff 50%, #0080ff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		.head-text-font {
			font-size: 1.4vw;
		}

		.head-English {
			position: absolute;
			top: 0.5vw;
			right: 1vw;
			width: 2.5vw;
			height: 2.5vw;
			cursor: pointer;
			z-index: 999;
			transition: all 0.3s ease;
			filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.3));

			&:hover {
				filter: drop-shadow(0 0 8px rgba(0, 240, 255, 0.6));
				transform: scale(1.1);
			}
		}
	}

	.login_ {
		z-index: 99;
		width: 90%;
		text-align: right;
		animation: slideUp 0.6s ease-out;
	}

	.login_ul {
		display: inline-block;
		padding: 2vw 2vw 1vw 2vw;
		text-align: center;
		background-size: 100% 100%;
		position: relative;

		/* Glowing border overlay */
		&::before {
			content: '';
			position: absolute;
			top: -1px;
			left: -1px;
			right: -1px;
			bottom: -1px;
			border: 1px solid rgba(0, 240, 255, 0.15);
			border-radius: 8px;
			pointer-events: none;
			animation: borderGlow 3s ease-in-out infinite;
		}

		/* Corner accents */
		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 30px;
			height: 30px;
			border-top: 2px solid var(--neon-cyan, #00f0ff);
			border-left: 2px solid var(--neon-cyan, #00f0ff);
			pointer-events: none;
		}

		.cocoLog {
			position: absolute;
			top: -4vw;
			left: 0;
			width: 100%;
			text-align: center;

			img {
				width: 5vw;
				filter: drop-shadow(0 0 10px rgba(0, 240, 255, 0.4));
				animation: floatY 3s ease-in-out infinite;
			}
		}

		.title {
			width: 170px;
			height: 21px;
			margin: 20px auto;
		}

		.login_button {
			margin: 1vw 0;
			width: 100%;
			color: white;
			padding: 0.4vw 0;
			background: linear-gradient(135deg, rgba(0, 128, 255, 0.8), rgba(0, 220, 255, 0.6));
			cursor: pointer;
			border-radius: 4px;
			font-size: 0.8vw;
			font-weight: 600;
			letter-spacing: 3px;
			position: relative;
			overflow: hidden;
			border: 1px solid rgba(0, 240, 255, 0.3);
			transition: all 0.3s ease;
			text-transform: uppercase;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: -100%;
				width: 100%;
				height: 100%;
				background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
				transition: left 0.5s ease;
			}

			&:hover {
				box-shadow: 0 0 15px rgba(0, 240, 255, 0.4), 0 0 30px rgba(0, 240, 255, 0.15);
				transform: translateY(-1px);
				border-color: rgba(0, 240, 255, 0.6);

				&::before {
					left: 100%;
				}
			}

			&:active {
				transform: translateY(0);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue